
import React from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

interface LocationFieldsProps {
  country: string;
  state: string;
  city: string;
  onFieldChange: (field: string, value: string) => void;
}

const LocationFields: React.FC<LocationFieldsProps> = ({
  country,
  state,
  city,
  onFieldChange,
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <div>
        <Label htmlFor="country">Country</Label>
        <Select 
          value={country} 
          onValueChange={(value) => onFieldChange('country', value)}
        >
          <SelectTrigger id="country" className="bg-[#9E7C47]/5 border-[#9E7C47]/30 text-white mt-1">
            <SelectValue placeholder="Select country" />
          </SelectTrigger>
          <SelectContent className="bg-black border-[#9E7C47]/30">
            <SelectItem value="India">India</SelectItem>
            <SelectItem value="USA">USA</SelectItem>
            <SelectItem value="UK">UK</SelectItem>
            <SelectItem value="Singapore">Singapore</SelectItem>
            <SelectItem value="Other">Other</SelectItem>
          </SelectContent>
        </Select>
      </div>
      
      <div>
        <Label htmlFor="state">State</Label>
        <Input
          id="state"
          placeholder="Enter state"
          value={state}
          className="bg-black border border-[#9E7C47]/30 text-white mt-1"
          onChange={(e) => onFieldChange('state', e.target.value)}
        />
      </div>
      
      <div>
        <Label htmlFor="city">City</Label>
        <Input
          id="city"
          placeholder="Enter city"
          value={city}
          className="bg-black border border-[#9E7C47]/30 text-white mt-1"
          onChange={(e) => onFieldChange('city', e.target.value)}
        />
      </div>
    </div>
  );
};

export default LocationFields;
